/**
 * @module app.core
 */

import * as Core from 'app/core/models/essette-api';
import { AssessmentAttachmentWithLocalState } from "app/core/models/local-state-extensions";
import { IQuestionComponent } from 'app/core/components/assessments/interfaces';
import { ITasksConfig } from 'app/core/models/essette-interfaces';


export class AssessmentContext {

    public attachment: AssessmentAttachmentWithLocalState = {};

    public currentSession: Core.AssessmentSession = {};

    public taskConfig: ITasksConfig | null = null;

    public questionComponents: IQuestionComponent[] = [];

    public unsavedChanges: boolean = false;

    public clear(): void {
        this.currentSession = {};
        this.attachment = {};
        this.taskConfig = null;
        this.questionComponents = [];
        this.unsavedChanges = false;
    }

}
